<style lang="less" scoped>
.query-title-div {
  width: 110px !important;
}

.lang-width {
  width: 450px !important;
}

.margin-tb {
  height: 32px;
  margin-top: 4px;
}

.refund-dialog /deep/ .el-dialog__header {
  text-align: center;
}

.refund-dialog .dialog-footer {
  display: flex;
  justify-content: center;
  gap: 12px;
}

.required-star {
  color: red;
  margin-right: 4px;
}
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">家庭充电订单列表</div>
      <div class="page-action-btns flex margin-tb-10">
        <div class="flex-grow-1"></div>
        <!-- <button class="common-bg-button" @click="handleEditOrView()">编辑/查看</button> -->
        <button class="common-bg-button" @click="handleRefund()">退 款</button>
        <button class="common-bg-button" @click="reset()">重 置</button>
        <button class="common-bg-button" @click="() => {
          showMultiQuerys = !showMultiQuerys;
        }">高级筛选</button>
        <button class="common-bg-button" @click="handleExport()">导 出</button>
      </div>
      <!-- 高级筛选 -->
      <div class="multi-query-div el-fade-in-linear" v-if="showMultiQuerys">
        <div class="margin-bottom-16">
          <el-row :gutter="20">
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">关键字搜索</p>
              <el-input clearable v-model="queryInfo.keyword" size="small" placeholder="请输入手机号"></el-input>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">购买类型</p>
              <el-select v-model="queryInfo.buyType" size="small" clearable placeholder="请选择购买类型" style="width: 100%">
                <el-option label="新499活动-用桩服务" value="NEW_499_PAY_ORDER" />
                <el-option label="新499活动-买断服务" value="NEW_499_BUYOUT_ORDER" />
              </el-select>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">退款操作时间</p>
              <el-date-picker class="full-width" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
                v-model="refundTime" @change="pickRefundDate(refundTime)" range-separator="-" start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-col>
            <!-- <el-col :span="8">
              <p class="margin-bottom-5 font-14">购买时间</p>
              <el-date-picker class="full-width" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
                v-model="createTime" @change="pickCreateDate(createTime)" range-separator="-" start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-col> -->
          </el-row>
          <el-row :gutter="20" style="margin-top: 16px;">
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">订单状态</p>
              <el-select v-model="queryInfo.orderStatus" size="small" clearable placeholder="请选择订单状态" style="width: 100%">
                <el-option label="已支付" value="PAY" />
                <el-option label="退款中" value="TO_REFUND" />
                <el-option label="已退款" value="REFUND" />
              </el-select>
            </el-col>
          </el-row>
        </div>
        <div class="margin-bottom-16">
        </div>
        <div class="page-action-btns flex margin-tb-10">
          <div class="flex-grow-1"></div>
          <button class="common-bg-button" @click="getListData(pagination, true)">搜 索</button>
        </div>
      </div>
      <!-- 表格 -->
      <div class="list-table">
        <ZD-table :tableColumns="pageConfig.listColumns" :operates="operates" :tableData="tableData"
          :tableConfig="pageConfig.tableConfig" :selections="selections"
          v-on:updateSelections="(sels) => { selections = sels }">
        </ZD-table>
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData"></ZD-pagination>
      </div>

      <!-- 服务类型选择弹窗 -->
      <el-dialog class="refund-dialog" title="请选择退款类型" :visible.sync="serviceTypeDialogVisible" width="30%">
        <el-form label-width="100px" size="small">
          <el-form-item label="退款类型:">
            <el-select v-model="selectedServiceType" placeholder="请选择退款类型" style="width: 100%">
              <el-option label="新499活动-用桩服务" value="USE_PILE" />
              <el-option label="新499活动-买断服务" value="BUYOUT" />
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="serviceTypeDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirmServiceType">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 退款弹窗 -->
      <el-dialog class="refund-dialog" title="退款金额确认" :visible.sync="dialogVisible" width="35%"
        @close="handleClose('refundForm')">
        <el-form ref="refundForm" :model="popFormInfo" :rules="rules" :hide-required-asterisk="true" label-width="150px"
          class="demo-ruleForm" size="small">
          <el-form-item label="退款支付宝账户:">
            <el-input v-model="popFormInfo.refundAlipayAccount" disabled />
          </el-form-item>
          <el-form-item label="订单名称:">
            <el-input v-model="popFormInfo.orderName" disabled />
          </el-form-item>
          <el-form-item prop="refundType">
            <template slot="label">
              <span class="required-star">*</span>退款类型:
            </template>
            <el-select v-model="popFormInfo.refundType" placeholder="请选择退款类型" style="width: 100%">
              <el-option label="全额退款" value="ALL" />
              <el-option label="部分退款" value="PART" />
              <el-option label="拒绝退款" value="REJECT" />
            </el-select>
          </el-form-item>
          <el-form-item prop="refundAmount" v-if="popFormInfo.refundType !== 'REJECT'">
            <template slot="label">
              <span class="required-star">*</span>退款金额:
            </template>
            <el-input-number v-model="popFormInfo.refundAmount" :min="0"
              :max="popFormInfo.maxRefundAmount || Number.MAX_SAFE_INTEGER" style="width: 100%" :step="1" />
          </el-form-item>
          <el-form-item prop="resetUse">
            <template slot="label">
              <span class="required-star">*</span>
              <span> 是否恢复服务使用:</span>
            </template>
            <el-select v-model="popFormInfo.resetUse" placeholder="请选择" style="width: 100%">
              <el-option label="是" value="Y" />
              <el-option label="否" value="N" />
            </el-select>
          </el-form-item>
          <el-form-item prop="refundReason">
            <template slot="label">
              <span class="required-star">*</span>退款原因:
            </template>
            <el-select v-model="popFormInfo.refundReason" placeholder="请选择退款原因" style="width: 100%">
              <el-option label="平台测算" value="平台测算" />
              <el-option label="用户申请" value="用户申请" />
              <el-option label="其他" value="其他" />
            </el-select>
          </el-form-item>
          <el-form-item prop="refundRemark">
            <template slot="label">
              <span class="required-star">*</span>退款原因备注:
            </template>
            <el-input type="textarea" v-model="popFormInfo.refundRemark" placeholder="请输入退款原因备注" :rows="3" />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose('refundForm')">取 消</el-button>
          <el-button type="primary" @click="makeSure('refundForm')">确认退款</el-button>
        </span>
      </el-dialog>

    </div>
  </div>
</template>

<script>
import pageConfig from './page-config'
import service from '@/utils/service'

export default {
  computed: {
    $S() {
      return service;
    }
  },
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      tableData: [], // 表格数据
      selections: [], // 表格选项
      pagination: pageConfig.pagination,
      queryInfo: {},
      createTime: [],
      refundTime: [],
      showMultiQuerys: false,
      operates: { list: [] },
      dialogVisible: false,
      serviceTypeDialogVisible: false, // 服务类型选择弹窗
      selectedServiceType: "", // 选择的服务类型: USE_PILE-用桩服务, BUYOUT-买断服务
      popFormInfo: {
        refundAlipayAccount: "",
        custMobile: "",
        mapNo: "", // 购买订单编号
        cancelNo: "", // 解约订单编号
        actualAmount: 0, // 实际支付金额
        refundAmount: 0, // 退款金额
        maxRefundAmount: Number.MAX_SAFE_INTEGER,
        custAccount: "", // 客户账户
        cancelAmount: 0, // 解约金额
        refundType: "ALL", // 退款类型，默认全额退款
        resetUse: "N", // 是否恢复服务使用，默认否
        refundReason: "",
        refundRemark: "",
        orderName: "" // 订单名称
      },
      rules: {
        refundType: [{ required: true, message: "请选择退款类型", trigger: "change" }],
        refundAmount: [
          { required: true, type: "number", message: "请输入退款金额", trigger: "change" },
          {
            validator: (_, value, cb) => {
              if (value === undefined || value === null || value === '') return cb(new Error("请输入退款金额"));
              if (Number.isNaN(Number(value))) return cb(new Error("金额需为数字"));
              if (Number(value) < 0) return cb(new Error("金额不能小于0"));
              return cb();
            }, trigger: ["blur", "change"]
          }
        ],
        resetUse: [{ required: true, message: "请选择是否恢复服务使用", trigger: "change" }],
        refundReason: [{ required: true, message: "请选择退款原因", trigger: "change" }],
        refundRemark: [{ required: true, message: "退款原因备注不能为空", trigger: "blur" }],
      }
    }
  },
  methods: {
    init() {
      this.getListData(this.pagination, true)
    },
    // 清理查询参数，移除空值
    cleanQueryInfo(queryInfo) {
      const clean = {};
      Object.keys(queryInfo).forEach(key => {
        const value = queryInfo[key];
        if (value !== null && value !== undefined && value !== '') {
          clean[key] = value;
        }
      });
      return clean;
    },
    getListData(pagination, reload = false) {
      let _ = this
      _.$U.showLoading(_)

      if (reload) {
        _.pagination.current = 1
        _.queryInfo.pageNum = 1
      } else {
        _.pagination.current = pagination.current
        _.queryInfo.pageNum = pagination.current
      }
      _.queryInfo.pageSize = pagination.pageSize;
      _.queryInfo.corpNo = _.$store.state.corpNo;
      const cleanQueryInfo = _.cleanQueryInfo(_.queryInfo);
      _.$H.post(_, _.$A.activityOrder.activityCommodityOrderList, cleanQueryInfo).then(res => {
        const payload = res?.data?.data || {}
        _.tableData = payload.content || []
        _.pagination.total = payload.totalElements || 0
        _.$U.hideLoading(_)
      }).catch(err => {
        _.tableData = []
        _.pagination.total = 0
        _.$U.hideLoading(_)
        console.error(err)
      })
    },
    pickCreateDate(time) {
      this.queryInfo.createFromTime = time ? time[0] : '';
      this.queryInfo.createToTime = time ? time[1] : '';
    },
    pickRefundDate(time) {
      this.queryInfo.refundFromTime = time ? time[0] : '';
      this.queryInfo.refundToTime = time ? time[1] : '';
    },
    checkSelectOne(selections) {
      if (selections.length < 1) {
        this.$U.error('请选择需要操作的对象');
        return false;
      }
      if (selections.length > 1) {
        this.$U.error('只能选择一个操作的对象');
        return false;
      }
      return true;
    },

    handleRefund() { 
      if (!this.checkSelectOne(this.selections)) {
        return;
      }

      // 检查退款状态
      const target = this.selections[0] || {};
      if (target.refundResult === 'SUCCESS') {
        this.$U.error('退款已完成,请勿重复提交');
        return;
      }

      // ----- orderType 自动判断服务类型---
      const orderType = target.orderType || "";
      if (orderType === "NEW_499_BUYOUT_ORDER") {
        this.selectedServiceType = "BUYOUT";
      } else if (orderType === "NEW_499_PAY_ORDER") {
        this.selectedServiceType = "USE_PILE";
      } else {
        this.$U.error("无法识别订单类型，请联系管理员");
        return;
      }
      
      // 直接打开退款弹窗
      this.openRefundDialog();
    },
    openRefundDialog() {
      const target = this.selections[0] || {};
      this.popFormInfo.refundAlipayAccount = target.mobile || target.orderNo || "";
      this.popFormInfo.custMobile = target.mobile || "";
      this.popFormInfo.mapNo = target.mapNo || "";
      this.popFormInfo.activityOrderNo = target.activityOrderNo || "";
      this.popFormInfo.orderName = target.orderName || ""; // 保存订单名称用于显示

      const actualAmount = Number(target.actualAmount || 0) || 0;
      const refundAmount = Number(target.refundAmount ?? target.actualAmount ?? 0) || 0;
      const maxRefundAmount = Number.isFinite(actualAmount) && actualAmount > 0
        ? actualAmount
        : Number.MAX_SAFE_INTEGER;
      this.popFormInfo.actualAmount = Number.isFinite(actualAmount) ? actualAmount : 0;
      this.popFormInfo.maxRefundAmount = Number.isFinite(maxRefundAmount) ? maxRefundAmount : Number.MAX_SAFE_INTEGER;
      this.popFormInfo.refundAmount = Math.min(refundAmount, this.popFormInfo.maxRefundAmount);
      this.popFormInfo.custAccount = target.mobile || "";
      this.popFormInfo.cancelAmount = Number(refundAmount) || 0;

      Object.assign(this.popFormInfo, {
        resetUse: "N", // 默认否
        refundType: "ALL", // 默认全额退款
        refundReason: "",
        refundRemark: ""
      });

      this.dialogVisible = true;
    },
    makeSure(formName) {
      console.log('refund click', this.popFormInfo, this.selections);
      const formRef = this.$refs[formName];
      if (!formRef || !formRef.validate) {
        this.$message.error("表单校验异常，请刷新后重试");
        return;
      }
      formRef.validate((valid) => {
        if (!valid) {
          console.warn('refund validate failed');
          return;
        }

        const target = this.selections[0] || {};

        let refundParams;
        let refundApi;

        if (this.selectedServiceType === 'BUYOUT') {
          // 买断服务用新接口和新传参
          refundParams = {
            cancelNo: String(this.popFormInfo.cancelNo || target.cancelNo || ""),
            refundAmount: Number(this.popFormInfo.refundAmount || target.refundAmount || 0),
            activityOrderNo: String(this.popFormInfo.activityOrderNo || target.activityOrderNo || ""),
            refundReason: String(this.popFormInfo.refundReason || ""),
            refundType: String(this.popFormInfo.refundType || "ALL"),
            refundRemark: String(this.popFormInfo.refundRemark || ""),
            resetUse: String(this.popFormInfo.resetUse || "N"),
            mapNo: String(this.popFormInfo.mapNo || target.mapNo || ""),
          };
          refundApi = this.$A.activityOrder.newActivityBuyoutRefund;
        } else {
          // 用桩服务用原接口和原传参
          refundParams = {
            cancelNo: String(this.popFormInfo.cancelNo || target.cancelNo),
            refundAmount: Number(this.popFormInfo.refundAmount || target.refundAmount || 0),
            activityOrderNo: String(this.popFormInfo.activityOrderNo || target.activityOrderNo || ""),
            refundReason: String(this.popFormInfo.refundReason || "用户申请"),
            refundType: String(this.popFormInfo.refundType || "ALL"),
            refundRemark: String(this.popFormInfo.refundRemark || "用户申请"),
            resetUse: String(this.popFormInfo.resetUse || "N"),
            corpNo: String(this.$store?.state?.corpNo || ""),
          };
          refundApi = this.$A.activityOrder.newActivityRefund;
        }
        const validations = [
          { field: 'activityOrderNo', message: '活动订单编号不能为空' },
          { field: 'refundType', message: '请选择退款类型' },
          { field: 'refundReason', message: '请选择退款原因' },
          { field: 'refundRemark', message: '退款原因备注不能为空' },
        ];
        const validateField = (value) => {
          if (value === null || value === undefined) return false;
          const str = String(value);
          return str !== "undefined" && str.trim() !== "";
        };
        for (const { field, message } of validations) {
          if (!validateField(refundParams[field])) {
            this.$U.error(message);
            return;
          }
        }
        const refundAmountNum = Number(refundParams.refundAmount);
        if (!validateField(refundParams.refundAmount) || isNaN(refundAmountNum) || refundAmountNum <= 0) {
          this.$U.error("退款金额必须大于0");
          return;
        }
        let _ = this;
        _.$U.showLoading(_);
        const refundTimeout = setTimeout(() => {
          _.$U.hideLoading(_);
          console.error('退款接口超时，未收到响应');
        }, 15000);

        _.$H.post(_, refundApi, refundParams)
          .then(res => {
            const result = res?.data || {};
            const isSuccess =
              result.status === 200 ||
              result.code === 200 ||
              result.success === true ||
              result.data === true;
            if (isSuccess) {
              _.$U.success("退款成功");
              _.dialogVisible = false;
              _.getListData(_.pagination, false);
            } else {
              const errorMsg = result.message || result.messge || result.msg || "退款提交失败，请重试";
              _.$U.error(errorMsg);
            }
          })
          .catch(err => {
            console.error("退款接口调用失败:", err);
            _.$U.error(err?.response?.data?.message || err?.message || "退款提交失败，请重试");
          })
          .finally(() => {
            clearTimeout(refundTimeout);
            _.$U.hideLoading(_);
          });
      });
    },
    handleClose(formName) {
      if (this.$refs[formName]?.resetFields) {
        this.$refs[formName].resetFields();
      }
      this.dialogVisible = false;
    },
    handleEditOrView() {
      if (!this.checkSelectOne(this.selections)) {
        return;
      }
      const target = this.selections[0] || {};
      this.$router.push({
        name: 'familyChargingProductOrderDetail',
        query: {
          mode: 'edit',
          orderNo: target.mapNo,
        },
      });
    },

    reset() {
      this.queryInfo = {};
      this.createTime = [];
      this.refundTime = [];
      this.getListData(this.pagination, true);
    },
    //导出
    handleExport() {
      let _ = this;
      let urls = "";
      const host = window.location.hostname;
      if (host.includes("shzhida.com")) {
        urls = "http://ocharge.shzhida.com:6771"; // 生产服务器
      } else {
        urls = "http://192.168.8.174:7997"; // 测试/开发服务器
      }
      const exportFileName = "家庭充电订单列表.xlsx";
      _.$U.showLoading(_);
      const exportQueryInfo = _.cleanQueryInfo(_.queryInfo);
      _.$H.post(_, _.$A.activityOrder.activityCommodityOrderListExcel, exportQueryInfo).then((res) => {
        if (res.data && res.data.data) {
          const exportData = res.data.data || {};
          exportData.fileName = exportFileName;
          if (exportData.base64) {
            _.$U.saveExcelFile(exportData);
          }
          if (exportData.filePath) {
            let downUrl = exportData.filePath;
            if (!downUrl.startsWith('http')) {
              downUrl = urls + downUrl;
            }
            if (window.location.protocol === 'https:' && downUrl.startsWith('http://')) {
              downUrl = 'https://' + downUrl.slice('http://'.length);
            }
            fetch(downUrl, { credentials: 'include' })
              .then(resp => resp.blob())
              .then(blob => {
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = exportFileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(link.href);
              })
              .catch(() => {
                const link = document.createElement('a');
                link.href = downUrl;
                link.download = exportFileName; // 
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              });
          }
          _.$U.success('导出成功');
        } else {
          _.$U.error(res.data?.msg || res.data?.message || '导出失败：未获取到文件信息');
        }
        _.$U.hideLoading(_);
      }).catch(err => {
        _.$U.hideLoading(_);
        console.error('导出失败:', err);
        _.$U.error(err?.response?.data?.msg || err?.response?.data?.message || err?.message || '导出失败');
      });
    },
  },
  mounted() {
    this.init()
  }
}
</script>